import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const GrowOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill={color}
        d="M12 2C6.49 2 2 6.49 2 12c0 2.88 1.25 5.63 3.42 7.53.19.16.38.32.58.47.03.02.06.03.09.04.04.02.09.05.13.06.06.02.12.03.18.04.03 0 .06.02.08.02.02 0 .04 0 .06-.01.05 0 .09-.01.13-.02.05-.01.1-.03.15-.05.04-.02.08-.04.12-.07.02-.02.05-.02.07-.04l5.87-5.14a.813.813 0 0 0 .02-1.21l-2.24-2.06L13.53 9v2.2c0 .45.37.82.82.82.45 0 .82-.37.82-.82V7.12c0-.45-.37-.82-.82-.82h-3.99c-.45 0-.82.37-.82.82 0 .45.37.82.82.82h1.92l-3.37 3.02c-.17.15-.27.37-.27.6 0 .23.09.45.26.61l2.23 2.05-4.66 4.08a8.362 8.362 0 0 1-2.83-6.27c-.01-4.64 3.75-8.4 8.36-8.4 4.61 0 8.37 3.75 8.37 8.37 0 4.62-3.75 8.37-8.37 8.37-.59 0-1.18-.06-1.75-.18a.826.826 0 0 0-.97.63c-.09.44.19.87.63.97.68.14 1.39.22 2.09.22 5.51 0 10-4.49 10-10S17.51 2 12 2Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default GrowOutlined
